export interface Resource {
  id: string;
  name: string;
  description: string;
  resourceUrl: string;
  resourceType: string;
}
